import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const metaData = [
    {
        name: 'twitter:card',
        content: 'summary_large_image',
        property: false,
    },
    {
        name: 'twitter:image',
        content: 'logo512.png',
        property: false,
    },
    {
        name: 'twitter:title',
        content: 'HRM GDN Bangladesh Limited Human Resource Management',
        property: false,
    },
    {
        name: 'twitter:creator',
        content: 'Rakibul Hasan',
        property: false,
    },
    {
        name: 'twitter:site',
        content: 'Rakibul Hasan',
        property: false,
    },
    {
        name: 'twitter:description',
        content:
            'HRM GDN Bangladesh Limited Human Resource Management created by Golden Infotech Limited',
        property: false,
    },
    {
        name: 'og:type',
        content: 'website',
        property: true,
    },
    {
        name: 'og:url',
        content: 'www.google.com',
        property: true,
    },
    {
        name: 'og:title',
        content: 'HRM GDN Bangladesh Limited Human Resource Management',
        property: true,
    },
    {
        name: 'twitter:description',
        content:
            'HRM GDN Bangladesh Limited Human Resource Management created by Golden Infotech Limited',
        property: true,
    },
    {
        name: 'og:image',
        content: 'logo512.png',
        property: true,
    },
];

const Page = ({
    children = <h4>Please add some children</h4>,
    metadata = metaData,
    title = '',
}) => {
    console.log('Rendering...');

    return (
        <Box>
            <Helmet>
                <title>{title}</title>
                {metadata.map((meta, index) =>
                    meta?.property ? (
                        <meta key={index} property={meta?.name} content={meta?.content} />
                    ) : (
                        <meta key={index} name={meta?.name} content={meta?.content} />
                    )
                )}
            </Helmet>
            {children}
        </Box>
    );
};

export default Page;
